var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.size},[_c('canvas',{ref:'chart',staticClass:"chart"})]),_vm._v(" "),_c('div',[_c('chart-legend',{attrs:{"labels":_vm.labels,"datasets":_vm.datasets},on:{"clicked":_vm.legendClicked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }